import { useTranslations } from "next-intl";

import type {
  TUseArticleCategoryFilter,
} from "@/ui/components/sections/articles/ArticleCategoryFilter/ArticleCategoryFilter.config";
import {
  useFiltersStore,
} from "libs/state/src/lib/stores/tanstack/filters/useFiltersStore";

export const useArticleCategoryFilter = (): TUseArticleCategoryFilter => {
  const t = useTranslations("Articles.Filters");
  const { updateFilters } = useFiltersStore();

  const onUpdateSelectedCategories = (value: string | string[]) => {
    if (Array.isArray(value)) {
      updateFilters("articles:categories", value);
      updateFilters("articles:page", 1);
    }
  };

  return {
    label: t("label"),
    placeholder: t("placeholder"),
    onUpdateSelectedCategories,
  };
};
